// extracted by mini-css-extract-plugin
export var AfterContentAuthor = "BlogDetails-module--AfterContentAuthor--32141";
export var AfterContentAuthorLink = "BlogDetails-module--AfterContentAuthorLink--5fed8";
export var AfterContentAuthorLinkIcons = "BlogDetails-module--AfterContentAuthorLinkIcons--712dd";
export var AfterContentContainer = "BlogDetails-module--AfterContentContainer--e1d67";
export var AfterContentIcons = "BlogDetails-module--AfterContentIcons--db485";
export var BlogBannerTime = "BlogDetails-module--BlogBannerTime--18016";
export var OtherBlogsContainer = "BlogDetails-module--OtherBlogsContainer--b62ee";
export var OtherBlogsContainerItem = "BlogDetails-module--OtherBlogsContainerItem--47711";
export var OtherBlogsWrap = "BlogDetails-module--OtherBlogsWrap--6cf78";
export var authorProfileContent = "BlogDetails-module--authorProfileContent--7d06d";
export var authorSocailMedia = "BlogDetails-module--authorSocailMedia--6484e";
export var bgVideo = "BlogDetails-module--bgVideo--786d1";
export var blogSingleBannerIcons = "BlogDetails-module--blogSingleBannerIcons--8ae63";
export var blogSingleBannerItems = "BlogDetails-module--blogSingleBannerItems--db58d";
export var blogSingleContainer = "BlogDetails-module--blogSingleContainer--a7268";
export var blogSingleContent = "BlogDetails-module--blogSingleContent--3acea";
export var blogSingleContentCategory = "BlogDetails-module--blogSingleContentCategory--6cbbc";
export var blogSingleContentCategoryWrap = "BlogDetails-module--blogSingleContentCategoryWrap--ea6f2";
export var blogSingleContentItems = "BlogDetails-module--blogSingleContentItems--cde19";
export var blogSingleContentItemsContainer = "BlogDetails-module--blogSingleContentItemsContainer--6c707";
export var blogSingleContentWrap = "BlogDetails-module--blogSingleContentWrap--bfd64";
export var blogSingleWrap = "BlogDetails-module--blogSingleWrap--61790";
export var categoryName = "BlogDetails-module--categoryName--c819f";
export var dateAndCategory = "BlogDetails-module--dateAndCategory--ae389";
export var desktopBlogs = "BlogDetails-module--desktopBlogs--5fd04";
export var mobileBlogs = "BlogDetails-module--mobileBlogs--8411a";
export var videoAlignmentClass = "BlogDetails-module--videoAlignmentClass--0ef62";
export var videoContainer = "BlogDetails-module--videoContainer--1214f";